import { countActionTypes, SETUPDATELENS } from '../../actions/simulationAdaptation/updateLens'

const reducer = (state = false, action: countActionTypes): boolean => {
  switch (action.type) {
    case SETUPDATELENS:
      return action.payload.n
    default:
      return state
  }
}

export default reducer
